/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import SocialMediaShare from "../../../molecules/social-media-share";
import "./resizer.m.css";

function Resizer({ story }) {
  const [toggleSharing, setToggleSharing] = useState(false);
  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  const handleFontSize = (value) => {
    const storyBody = document.getElementById(`story-content-${story.id}`);

    if (storyBody.classList.contains("big")) {
      storyBody.classList.remove("big");
    } else if (storyBody.classList.contains("medium")) {
      storyBody.classList.remove("medium");
    } else if (storyBody.classList.contains("small")) {
      storyBody.classList.remove("small");
    }
    storyBody.classList.add(value);
  };

  return (
    <div styleName="wrapper">
      <div styleName="resizer">
        <div styleName="title">ಅಕ್ಷರ ಗಾತ್ರ</div>
        <button styleName="resizer-button small-font" onClick={() => handleFontSize("small")}>
          <span styleName="resize-span">ಅ</span>
        </button>
        <button styleName="resizer-button medium-font" onClick={() => handleFontSize("medium")}>
          <span styleName="resize-span">ಅ</span>
        </button>
        <button styleName="resizer-button big-font" onClick={() => handleFontSize("big")}>
          <span styleName="resize-span">ಅ</span>
        </button>
      </div>
      <div styleName="share">
        <button styleName="share-btn" onClick={sharingHandler}>
          <SvgIconHandler type="shareicon" />
        </button>
        <div styleName="share-options">{toggleSharing && <SocialMediaShare story={story} />}</div>
      </div>
    </div>
  );
}

export default Resizer;
